import { render, staticRenderFns } from "./card-generic-v2.vue?vue&type=template&id=70fbaf28&"
import script from "./card-generic-v2.vue?vue&type=script&lang=ts&"
export * from "./card-generic-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports